// React hook for fetching live site settings (incl. storm mode + dry-run flag).
import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;
let _cacheAt = 0;
const TTL = 60_000; // 60 seconds

export function useSiteSettings() {
    const [data, setData] = useState(_cache);
    const [loading, setLoading] = useState(!_cache);

    useEffect(() => {
        let active = true;
        const now = Date.now();
        if (_cache && now - _cacheAt < TTL) {
            setData(_cache);
            setLoading(false);
            return;
        }
        api
            .get("/site-settings")
            .then((res) => {
                if (!active) return;
                _cache = res.data;
                _cacheAt = Date.now();
                setData(res.data);
            })
            .catch(() => {
                if (active) setData(null);
            })
            .finally(() => active && setLoading(false));
        return () => {
            active = false;
        };
    }, []);

    return { settings: data, loading };
}
